'use client';

import { useMemo } from 'react';
import type { TaxonomyOption, TaxonomyTerm } from '../../model/product/taxonomy';
import { useProductService } from './useProductService';

export const useSkinConcern = () => {
  const { useGetSuspenseProductTaxonomy } = useProductService();
  const { data: taxonomy } = useGetSuspenseProductTaxonomy();

  return useMemo(() => {
    const defaultOption: TaxonomyOption = { label: 'All concerns', value: 'all' };

    if (!taxonomy?.skinConcern || taxonomy.skinConcern.length === 0) {
      return [defaultOption];
    }

    return [
      defaultOption,
      ...taxonomy.skinConcern.map((concern: TaxonomyTerm) => ({
        label: concern.name,
        value: concern.slug,
      })),
    ];
  }, [taxonomy]);
};
